// components/TextInput.tsx
import { useFormContext } from 'react-hook-form';

import type { FormOptions, GeneralFormProps } from '@/types/general';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../ui/form';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';

type Props = {
  options: FormOptions;
  helperText?: string;
} & Omit<GeneralFormProps, 'description'>;
function RHFShadcnRadioGroup({
  name,
  options,
  title,
  helperText,
  required,
  value: externalValue,
  onChange: externalOnChange,
}: Props) {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormItem className="w-full">
          {title !== undefined && title !== '' && (
            <FormLabel className="mb-1.5 block type-label-l text-foreground">
              {title}
              {required === true && (
                <span aria-label="required" className="text-error ml-1">*</span>
              )}
            </FormLabel>
          )}
          <FormControl>
            <RadioGroup
              data-testid={field.name}
              onValueChange={(e) => {
                if (externalOnChange) {
                  externalOnChange(e);
                  return;
                }
                field.onChange(e);
              }}
              required={required}
              defaultValue={
                (field.value !== undefined
                  ? field.value
                  : externalValue) as string
              }
              className="flex flex-col gap-2"
            >
              {options.map(item => (
                <div
                  key={item.value}
                  className="flex items-center gap-3"
                >
                  <RadioGroupItem value={item.value} id={`${field.name}-${item.value}`} />
                  <label
                    htmlFor={`${field.name}-${item.value}`}
                    className="type-body-m text-foreground cursor-pointer"
                  >
                    {item.label}
                  </label>
                </div>
              ))}
            </RadioGroup>
          </FormControl>
          {helperText !== undefined && helperText !== '' && fieldState.error === undefined && (
            <FormDescription className="mt-1.5 type-body-s text-on-surface-variant">
              {helperText}
            </FormDescription>
          )}
          <FormMessage className="mt-1.5" />
        </FormItem>
      )}
    />
  );
}

export default RHFShadcnRadioGroup;
